import React from 'react';
import card from '../../../images/card.png';
import n from '../../../images/giftcard-n.svg';
import circles from '../../../images/giftcard-circles.svg';
import circletn from '../../../images/giftcard-circle-tn.svg';
import circlebig from '../../../images/giftcard-circle-big.svg';
import star from '../../../images/giftcard-star.svg';
import line from '../../../images/giftcard-line.svg';

const GiftCardTheCard = () =>(
    <>
        <section className="giftCardsTheCard">
            <img src={card} className="card"/>
            <img src={n} className="n"/>
            <img src={circles} className="circles"/>
            <img src={circletn} className="circletn"/>
            <img src={circlebig} className="circlebig"/>
            <img src={star} className="star"/>
            <img src={line} className="line"/>
        </section>
    </>
)

export default GiftCardTheCard;